import { useEffect, useState } from 'react';

/** O relógio da tela, em ms, renovado a cada `ms`. Faz "há 40 s" andar sem recarregar a lista. */
export function useAgora(ms = 30_000): number {
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setAgora(Date.now()), ms);
    return () => clearInterval(t);
  }, [ms]);
  return agora;
}
